import React from 'react'
import './gpt3.css'
const GPT3 = () => {
    return (
        <div className='gpt3__wgpt3' id='wgpt3'>
            <div className="wgpt3">
                <div className="heading">
                    <h2>What Is GPT-3</h2>
                    <p>We so opinion friends me message as delight. Whole front do of plate heard oh ought. His defective nor convinced residence own. Connection has put impossible own apartments boisterous. At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by.</p>
                </div>
                <div className="subtitle">
                    <h1>The possibilities are beyond your imagination</h1>
                    <a href="#">Explore The Library</a>
                </div>
                <div className="cards">
                    <div className="card">
                        <h2>Chatbots</h2>
                        <p>We so opinion friends me message as delight. Whole front do of plate heard oh ought. </p>
                    </div>
                    <div className="card">
                        <h2>Knowledgebase</h2>
                        <p>At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by. As put impossible own apartments b</p>
                    </div>
                    <div className="card">
                        <h2>Education</h2>
                        <p>At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by. As put impossible own apartments b</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GPT3
